export enum InventoryControlMethodEnum {
  FIRST_IN_FIRST_OUT = 'first_in_first_out',
  LAST_IN_FIRST_OUT = 'last_in_first_out',
  HIGHEST_IN_FIRST_OUT = 'highest_in_first_out',
  LOWEST_IN_FIRST_OUT = 'lowest_in_first_out',
  FIRST_EXPIRED_FIRST_OUT = 'first_expired_first_out',
}
